module.exports = __webpack_public_path__ + "img/30.f10baf30.png";